import { render } from "./HealthStatsBloc.vue?vue&type=template&id=1187e21b&scoped=true"
import script from "./HealthStatsBloc.vue?vue&type=script&lang=js"
export * from "./HealthStatsBloc.vue?vue&type=script&lang=js"

import "./HealthStatsBloc.vue?vue&type=style&index=0&id=1187e21b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1187e21b"]])

export default __exports__